<template>
  <BaseModal
    ref="BaseModal"
    title="Pedido de Alteração"
  >
    <div class="mt-2">
      <!--      <div v-if="preapproval_content" class="mb-3">-->
      <!--        <label>Conteúdo da Liberação para Aprovação</label>-->
      <!--        <div class="form-control h-auto overflow-auto" style="max-height: 300px" v-html="preapproval_content"></div>-->
      <!--      </div>-->
      <label>Digite aqui o motivo</label>
      <HtmlEditor
        v-model="content"
      />
    </div>
    <div class="mt-2">
      <label class="col-12">Anexar arquivos</label>
      <UploadsEditor
        :param="{ customer_id, ticket_id, ticket_detail_id }"
      />
    </div>
    <template v-slot:footer>
      <button :disabled="!content" class="btn btn-primary" @click="confirm()">Confirmar pedido</button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '../components/BaseModal'

export default {
  name: 'ConfirmAskChange',
  components: {BaseModal},
  data () {
    return {
      customer_id: '',
      ticket_detail_id: '',
      ticket_id: '',
      content: '',
      preapproval_content: ''
    }
  },
  methods: {
    show ({ customer_id, ticket_id, ticket_detail_id, preapproval_content }, callback) {
      this.customer_id = customer_id
      this.ticket_id = ticket_id
      this.ticket_detail_id = ticket_detail_id
      this.preapproval_content = preapproval_content
      this.$refs.BaseModal.show()
      this.callback = callback
    },
    confirm () {
      this.callback(this.content)
      this.$refs.BaseModal.hide()
    }
  }
}
</script>

<style scoped>

</style>
